import $ from 'jquery';
import populateCarousels from './populateCarousels';
import { product_carousels, initProductCarousels } from './carousel';

export default function() {
  $(document).on('shopify:section:load', (e) => {
    if (e.detail.sectionId !== 'INF-ProductOverview') { return; }

    populateCarousels();
    const $carousels = $('[data-product-images-carousel]');

    if ($carousels.length > 0) {
      initProductCarousels();
      
      if ($('[data-custom-variant-selector]').is('select')) {
        $('[data-custom-variant-selector]').selectric('refresh').trigger('change');
      } else {
        $('.ProductOption__variant--selected').trigger('click');
      }
      
      window.triggerResize();
    }

    $(`#Section${e.detail.sectionId} select`).selectric();
  });

  $(document).on('shopify:section:unload', (e) => {
    if (e.detail.sectionId !== 'INF-ProductOverview') { return; }
    
    const $carousels = $('[data-product-images-carousel]');

    if ($carousels.length > 0) {
      $carousels.each((i, carousel) => {
        const id = $(carousel).attr('id');
        if (product_carousels[id]) {
          product_carousels[id].destroy();
          delete product_carousels[id];
        }
      });
    }
  });
}